export const SkillsData = [
  {
    list: [
      {
        name: "HTML",
        icon: <i class="devicon-html5-plain colored"></i>,
      },
      {
        name: "CSS",
        icon: <i class="devicon-css3-plain colored"></i>,
      },
      {
        name: "Bootstrap",
        icon: <i class="devicon-bootstrap-plain colored"></i>,
      },
      {
        name: "Tailwind CSS",
        icon: <i class="devicon-tailwindcss-plain colored"></i>,
      },
      {
        name: "Material UI",
        icon: <i class="devicon-materialui-plain colored"></i>,
      },
      {
        name: "Sass",
        icon: <i class="devicon-sass-original colored"></i>,
      },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>,
      },
      {
        name: "ReactJS",
        icon: <i class="devicon-react-original colored"></i>,
      },
      {
        name: "Redux",
        icon: <i class="devicon-redux-original colored"></i>,
      },
      {
        name: "NextJS",
        icon: <i class="devicon-nextjs-original colored"></i>,
      },
      {
        name: "Git",
        icon: <i class="devicon-git-plain colored"></i>,
      },
      {
        name: "npm",
        icon: <i class="devicon-npm-original-wordmark colored"></i>,
      },
      {
        name: "Firebase",
        icon: <i class="devicon-firebase-plain colored"></i>,
      },
      {
        name: "MongoDB",
        icon: <i class="devicon-mongodb-plain colored"></i>,
      },
      {
        name: "Express",
        icon: <i class="devicon-express-original-wordmark"></i>,
      },
      {
        name: "NodeJS",
        icon: <i class="devicon-nodejs-plain colored"></i>,
      },
      {
        name: "VSCode",
        icon: <i class="devicon-vscode-plain colored"></i>,
      },
      {
        name: "Photoshop",
        icon: <i class="devicon-photoshop-plain colored"></i>,
      },
      {
        name: "Figma",
        icon: <i class="devicon-figma-plain colored"></i>,
      },
    ],
  },
];
